const Banner = '/assets/busesbarriaI/general/main-banner.jpg';
const HeaderLogo = '/assets/busesbarriaI/general/header-logo.png';
const FooterLogo = '/assets/busesbarriaI/general/footer-logo.png';
const BookingInActive = '/assets/busesbarriaI/general/booking-inactive.svg';
const BookingActive = '/assets/busesbarriaI/general/booking-active.svg';
const CancelInActive = '/assets/busesbarriaI/general/cancel-inactive.svg';
const CancelActive = '/assets/busesbarriaI/general/cancel-active.svg';

const Whatsapp = '/assets/kennybus/icons/whatsapp.svg';
const Email = '/assets/busesbarriaI/icons/email.svg';
const HeadPhone = '/assets/busesbarriaI/icons/headphone.svg';
const YellowLine = '/assets/busesbarriaI/icons/blue-line.svg';

const OriginIcon = '/assets/busesbarriaI/icons/origin.svg';
const DestinationIcon = '/assets/busesbarriaI/icons/destination.svg';
const pin = '/assets/busesbarriaI/icons/pin-icon.svg';
const CalendarIcon = '/assets/busesbarriaI/icons/calender.svg';

const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/busesbarriaI/general/where-to-find-pnr.svg';
const success = '/assets/bahia/Blue/MyAccount-IllustratedIcons-CheckMark-Blue.svg';
const failure = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Information-Blue.svg';
const PopupIcon = '/assets/kennybus/general/Pop-up.jpg';

// Icons Section
const ist = '/assets/busesbarriaI/icons/icon-1.svg';
const second = '/assets/busesbarriaI/icons/icon-2.svg';
const third = '/assets/busesbarriaI/icons/icon-3.svg';
const close = '/assets/busesbarriaI/icons/close.png';
const address = '/assets/busesbarriaI/icons/address.svg';


const tick = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Tick-Blue.svg';
const heartOn = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOn-Blue.svg';
const heartOff = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOff-Blue.svg';
const downArrow = '/assets/bahia/Blue/MyAccount-IllustratedIcons-DropDown-Blue.svg';
const registrationSuccess = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RightDocument-Blue.svg';
const userIcon = '/assets/bahia/Home/user_red_dot-BahiaAzul.svg';
const trips = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyTrips-Blue.svg';
const cards = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyCards-Blue.svg';
const wallet = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const transaction = '/assets/bahia/Blue/MyAccount-IllustratedIcons-ShareMoney-Blue.svg';
const otp = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RestorePassword-Blue.svg';

const kennybusIcons = [

  { icon: downArrow, name: 'downArrow' },
  { icon: userIcon, name: 'userIcon' },
  { icon: trips, name: 'trips' },
  { icon: cards, name: 'cards' },
  { icon: wallet, name: 'wallet' },
  { icon: transaction, name: 'transaction' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: tick, name: 'tick' },
  { icon: heartOn, name: 'heartOn' },
  { icon: heartOff, name: 'heartOff' },
  { icon: registrationSuccess, name: 'registrationSuccess' },
  { icon: otp, name: 'otp' },

  { icon: Banner, name: 'Banner' },

  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: HeaderLogo, name: 'headerLogo' },
  { icon: FooterLogo, name: 'footerLogo' },
  { icon: address, name: 'address' },

  { icon: OriginIcon, name: 'Origin' },
  { icon: DestinationIcon, name: 'Destination' },
  { icon: pin, name: 'pin' },
  { icon: CalendarIcon, name: 'Calendar' },

  { icon: BookingInActive, name: 'BIA' },
  { icon: BookingActive, name: 'BA' },
  { icon: CancelInActive, name: 'CIA' },
  { icon: CancelActive, name: 'CA' },

  { icon: PopupIcon, name: 'Popup' },

  { icon: Whatsapp, name: 'Whatsapp' },
  { icon: Email, name: 'Email' },
  { icon: HeadPhone, name: 'Headphone' },
  { icon: YellowLine, name: 'Line' },

  { icon: animation, name: 'animation' },
  { icon: checkboxIcon, name: 'Checkbox' },

  // Icons Section
  { icon: ist, name: 'ist' },
  { icon: second, name: 'second' },
  { icon: third, name: 'third' },
  { icon: pnr, name: 'pnr' },
  { icon: close, name: 'close' },
];

export default kennybusIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/busesbarriaIcons.js